import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const CollectionPointBasicInfoComponent = ({ onInnerFormChange, selectedCollection }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'CollectionPointInfo.Name',
                  selectedCollection?.CollectionPointInfo
                )
              }}
              type="text"
              value={selectedCollection?.CollectionPointInfo?.Name}
          />
      <InputContainer
              label="PhoneNumber"
              name="PhoneNumber"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'CollectionPointInfo.PhoneNumber',
                  selectedCollection?.CollectionPointInfo
                )
              }}
              type="text"
              value={selectedCollection?.CollectionPointInfo?.PhoneNumber}
          />
     </div>
        }
        expandedPanel="basicInfo"
        headerTitle="Basic Info"
    />
</>
)
export default CollectionPointBasicInfoComponent;
